// Frame and label styling for the JSON editor, ported off a global stylesheet the
// module cannot carry with it. Colours come from the host app's --if-* layer.

import styled, { css } from 'styled-components';

export const EditorFrame = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid var(--if-border-strong);

  ${({ $disabled }) =>
    $disabled
      ? css`
          background: var(--if-surface-2-50);
          cursor: not-allowed;
        `
      : css`
          background: var(--if-surface-1);

          &:hover {
            border: 1px solid var(--if-accent-hover);
          }
        `}
`;

export const FieldLabel = styled.span`
  font-weight: 500;
  color: var(--if-ink-2);
  font-size: 0.75rem;
  line-height: 140%;
  text-align: left;
  padding-left: 10px;
  padding-top: 5px;
  font-family: 'Montserrat', sans-serif;
`;

export const RequiredMark = styled.span`
  display: inline;
  margin-left: 3px;
  color: var(--if-info);
`;
